<template>
    <div class="review">
        <hr>
        <div class="review-heading">
            <p class="review-info">
                <span class="review-username">{{ review.username }}</span><span class="hidden-xs">,</span>

                {{ review.state }}<span class="hidden-xs">.</span>
                <i>
                    <span class="hidden-xs">Reviewed on</span> {{ review.date | shortHumanizeDate }}
                </i>
            </p>
            <div class="review-rating">
                <star-rating
                    :rating="+review.rating"
                    active-color="#640a92"
                    inactive-color="#5f686d"
                    :star-size="17"
                    :show-rating="false"
                    :increment="0.5"
                    :border-width="2"
                    :rounded-corners="true"
                    :read-only="true"
                    :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
                />
            </div>
        </div>
        <p class="review-text">
            <template v-if="shouldShowFullReview">
                {{ review.description }}
            </template>
            <template v-else>
                {{ review.description | truncate(200, '...', false) }}
            </template>
        </p>
        <a v-if="review.description.length >= 200" href="javascript:void(0)"
            @click="shouldShowFullReview = !shouldShowFullReview"
            class="review-show-more">
            <template v-if="shouldShowFullReview">
                &leftarrow; Show Less
            </template>
            <template v-else>
                Show More &rightarrow;
            </template>
        </a>
    </div>
</template>

<script>
export default {
    name: "SingleReview",
    props: {
        review: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            shouldShowFullReview: false
        }
    }
}
</script>

<style lang="scss">
@media (max-width: 580px) {
    .review {
        &-rating {
            .vue-star-rating-star {
                margin: 0 !important;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.review {
    margin-bottom: 45px;

    hr {
        border-top: 1px solid #dadde0;
        margin-bottom: 15px;
    }

    &-heading {
        display: flex;
        margin-bottom: 15px;
    }

    &-info {
        margin-right: auto;
        color: #5F707F;
        font-size: 16px;

        @media (max-width: 580px) {
            display: flex;
            flex-direction: column;
        }
    }

    &-username {
        font-weight: 700;
        color: $black;
    }

    &-text {
        color: #5F707F;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 5px;
    }

    &-show-more {
        color: #792B99;
        font-size: 16px;

        &:hover {
            color: darken(#792B99, 10%);
            text-decoration: underline;
        }
    }
}
</style>

